import {Lead} from '../../data/domain/lead';
import {birthdate} from '../../common/dates';
import {DateTime} from 'luxon';
import {
  SessionDTO,
  Sex,
  SubscriptionAnimationDTO,
  SubscriptionDTO,
  WaitingSubscriptionDTO
} from '@minutespourtoi/api-models/dist/models';


export const leadDTOToExistingSubscriptionDTO = (session: SessionDTO, leadDTO: Lead, subscriptionDTO: SubscriptionDTO) => {

  subscriptionDTO.sex = leadDTO.sex == "M" ? Sex.M : Sex.F
  subscriptionDTO.birthDate = birthdate(leadDTO.age)
  subscriptionDTO.createdAt = DateTime.now().toMillis()
  subscriptionDTO.desiredSearchAgeMin = leadDTO.desiredAgeMin
  subscriptionDTO.desiredSearchAgeMax = leadDTO.desiredAgeMax
  subscriptionDTO.discountCode = leadDTO.discount?.discountCode
  subscriptionDTO.offerCode = leadDTO.offer.code
  subscriptionDTO.sessionId = leadDTO.sessionId
  subscriptionDTO.searchSex = leadDTO.sex == "M" ? Sex.F : Sex.M
  subscriptionDTO.options = leadDTO.options.map(optionIn => optionIn.code)
  subscriptionDTO.animation = new SubscriptionAnimationDTO()
  subscriptionDTO.animation.myProfile = leadDTO.myProfile
  subscriptionDTO.animation.animationCityId = leadDTO.animationCityId
  subscriptionDTO.animation.animationCityName = leadDTO.animationCityName
  subscriptionDTO.reducedMobility = leadDTO.reducedMobility
  if(session.topic == "lgbt_w") {
    subscriptionDTO.topicOption = leadDTO.topicOption
    subscriptionDTO.topicSearchOptions = leadDTO.topicSearchOptions
  }
  return subscriptionDTO
}

export const leadDTOToWaitingSubscriptionDTO = (session: SessionDTO, leadDTO: Lead) => {

  const waitingSubscriptionDTO = new WaitingSubscriptionDTO()
  waitingSubscriptionDTO.sex = leadDTO.sex as Sex
  waitingSubscriptionDTO.email = leadDTO.email
  waitingSubscriptionDTO.firstname = leadDTO.firstname
  waitingSubscriptionDTO.phone = leadDTO.phone
  waitingSubscriptionDTO.birthDate = birthdate(leadDTO.age)
  waitingSubscriptionDTO.createdAt = DateTime.now().toMillis()
  waitingSubscriptionDTO.desiredSearchAgeMin = leadDTO.desiredAgeMin
  waitingSubscriptionDTO.desiredSearchAgeMax = leadDTO.desiredAgeMax
  waitingSubscriptionDTO.discountCode = leadDTO.discount?.discountCode
  waitingSubscriptionDTO.offerCode = leadDTO.offer.code
  waitingSubscriptionDTO.sessionId = leadDTO.sessionId
  waitingSubscriptionDTO.searchSex = leadDTO.sex == "M" ? Sex.F : Sex.M
  waitingSubscriptionDTO.options = leadDTO.options.map(optionIn => optionIn.code)
  waitingSubscriptionDTO.animation = new SubscriptionAnimationDTO()
  waitingSubscriptionDTO.animation.myProfile = leadDTO.myProfile
  waitingSubscriptionDTO.animation.animationCityId = leadDTO.animationCityId
  waitingSubscriptionDTO.animation.animationCityName = leadDTO.animationCityName
  waitingSubscriptionDTO.topicSearchOptions = leadDTO.topicSearchOptions
  waitingSubscriptionDTO.reducedMobility = leadDTO.reducedMobility
  if(session.topic == "lgbt_w") {
    waitingSubscriptionDTO.topicOption = leadDTO.topicOption
    waitingSubscriptionDTO.topicSearchOptions = leadDTO.topicSearchOptions
  }

  return waitingSubscriptionDTO
}
